import { makeStyles } from "@material-ui/core";

export const useVerticalTabsStyles = makeStyles(() => ({
    tabsContainerRoot: {
        display: "flex",
        overflow: "hidden",
    },
    tabsRoot: {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        flexShrink: 0,
        width: 80,
        "& .MuiTab-root": {
            fontSize: "1.3rem",
            fontWeight: 400,
            minWidth: 80,
            textTransform: "none",
            "&.Mui-selected": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
        },
    },
}));
